import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import NotificationCategoryUpdate from 'components/NotificationCategory/Update';

const ScreenNotificationCategoryUpdate = ({ classes, match }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <NotificationCategoryUpdate id={match.params.id} />
      </GridItem>
    </GridContainer>
  </div>
);

ScreenNotificationCategoryUpdate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(
  ScreenNotificationCategoryUpdate,
);
